var generic = generic || {};

(function ($) {
  Drupal.behaviors.productKitV1 = {
    attach: function (context) {
      var $kitWrapper = $('.js-product-kit-formatter-v1', context);
      var productCount = 0;
      var $kitMenuItem = $('.js-product-kit-v1', $kitWrapper);
      var accordionCount = $kitMenuItem.length;
      var $prodSelectedCount = $('.js-selected-count', $kitWrapper);
      var $totalProductsCount = $('.js-total-count', $kitWrapper);
      var $productCarousel = $('.js-product-kit-container', $kitWrapper);
      var $kitOptions = $(
        '.js-close, .js-edit, .js-select, .js-label-info, .js-kit-label',
        $kitWrapper
      );
      var $skuSelect = $('select', $kitWrapper);
      var $kitPriceContainer = $('.js-total-price', $kitWrapper);
      var $kitDiscountPriceContainer = $('.js-discount-price', $kitWrapper);
      var $kitDiscountPercent = $('.js-discount-percent', $kitWrapper);
      var kitDiscountPercentText = $kitDiscountPercent.data('discountPercentText');
      var kitPrice = 0;
      var $addToBag = $('.js-add-to-kit', $kitWrapper);
      var $shadeSelect = $('select.js-shades', $kitWrapper);
      var $sizeSelector = $('select.js-sizes', $kitWrapper);
      var $productUnitPrice = $('.js-unit-price', context);
      var currencySymbol = $kitWrapper.data('currency-symbol');
      var thousandsSeparator = $kitWrapper.data('thousands-separator');
      var decimalSeparator = $kitWrapper.data('decimal-separator');
      var showPricePerML = $kitWrapper.data('show-price-per-ml');
      var showSelect = $('.js-kit-product-select-cta').data('show-select');
      var showSelected = $('.js-kit-product-select-cta').data('show-selected');
      var $document = $(document);
      var isMobile = $('body').hasClass('device-mobile');
      var offerDetails = {};
      var $productList = $('.js-product-list', $kitWrapper);
      var $kitSku = $();
      var oosCount;
      var $kitItemElement = $();
      var invStatus;
      var $itemElement = $();
      var $gridImage = $('.js-mpp-grid--carousel', context);
      var $productDetail = $('.js-kit-details', context);
      var $showPopup = $('.js-product-kit-show-popup', context);
      var $closePopup = $('.js-product-kit-close-popup', context);
      var $productTitle = $('.js-prod-title', context);
      var $productSubtitle = $('.js-prod-sub-title', context);
      var $reviewContainer = $('.js-star-rating', context);
      var $whoitisfor = $('.js-whoitisfor-desc', context);
      var $whatitis = $('.js-whatitis-desc', context);
      var $whatitdoes = $('.js-whatitdoes-desc', context);
      var $firstAccordion = $();
      var calculateDiscountPrice;
      var formatPrice;
      var updateKitPrice;
      var getRatingPercentage;
      var fetchOffers;
      var skuChange;
      var dropdownChange;
      var productInfo;
      var $firstOptionSku;
      var fillProductProperties;
      // Handle displaying server errors
      const handleServerError = function (response) {
        // Re-enable the add button whether the request was successful or not
        $addToBag.removeClass('button--disabled').addClass('active');

        const errorObjectsArray = response.getMessages();
        const allErrorsHtml = errorObjectsArray.map(
          (errorObj) => '<div>' + errorObj.text + '</div>'
        );

        $document.trigger('addToCart.failure', [errorObjectsArray]);

        // Send all errors to overlay
        generic.overlay.launch({
          content: allErrorsHtml,
          includeBackground: true,
          cssStyle: {
            width: '324px',
            padding: '25px'
          }
        });
      };

      // Set product properties
      fillProductProperties = function ($product, $skuOption) {
        var skuId = $skuOption.data('skuBaseId');
        var skuPrice = $skuOption.data('skuPrice');
        var formattedPrice = $skuOption.data('formattedPrice');
        var prodCode = $skuOption.data('prodCode');
        var skuImage = '/media/export/cms/products/302x349/clq_' + prodCode + '_302x349.png';

        $product.attr({
          'data-price': skuPrice,
          'data-formatted-price': formattedPrice,
          'data-sku-base-id': skuId
        });

        if (isMobile) {
          $product.find('.js-sku-price').text(formattedPrice);
          $product.closest('.js-product-info').find('.js-sku-price').html(formattedPrice);
          $product.find('.js-kit-image').attr('src', skuImage);
        } else {
          $product.find('.js-kit-image').attr('src', skuImage);
          $product.find('.js-product-kit-info').find('.js-sku-price').html(formattedPrice);
        }
      };

      $productList.each(function (index, item) {
        $itemElement = $(item);
        $kitSku = $itemElement.find('option.js-kit-size-option');
        oosCount = 0;
        if (showPricePerML === '' || showPricePerML === 0) {
          $productUnitPrice.html('');
        }

        // Get the defaultSku inv status
        invStatus = parseInt(
          $itemElement.find('.product-size.js-kit-size-option').data('inventoryStatus'),
          10
        );

        //  2 - Out of Stock, 5 - Inactive, 7 - Sold Out
        if (invStatus === 2 || invStatus === 5 || invStatus === 7) {
          if ($kitSku.length > 0) {
            // Select the first option because defaultSku is OOS, Inactive or Sold Out
            $firstOptionSku = $kitSku.first();
            fillProductProperties($itemElement, $firstOptionSku);
            $firstOptionSku.attr('selected', true);
          }
          oosCount++;
        }

        // Remove the product if the defaultSku is invalid and has no available options
        if (oosCount > $kitSku.length) {
          $itemElement.remove();
        }
      });

      calculateDiscountPrice = function (totalPrice) {
        var offers = offerDetails.offers;
        var percentDiscountedPrice = 0;
        var flatDiscountedPrice = 0;
        var discountedPrice = 0;
        var discountValue;
        var discountType = '';

        if (offers && typeof offers === 'object') {
          $.each(offers, function (offerCode, offerValues) {
            if (offerValues.fields.impossible !== 1) {
              $.each(offerValues.fields.benefits, function (index, benefits) {
                if (benefits.class === 'PercentDiscount') {
                  percentDiscountedPrice = (totalPrice * benefits.value) / 100;
                  discountType = benefits.value.toString();
                } else if (benefits.class === 'FlatDiscount') {
                  flatDiscountedPrice = benefits.value;
                  discountType = currencySymbol + benefits.value.toString();
                }
                $kitPriceContainer.addClass('strike-out-price');
              });
            }
          });
          discountValue =
            percentDiscountedPrice > flatDiscountedPrice
              ? percentDiscountedPrice
              : flatDiscountedPrice;
          discountedPrice = totalPrice - discountValue;
          $kitDiscountPriceContainer.text(currencySymbol + formatPrice(discountedPrice));
          $kitPriceContainer.text(currencySymbol + formatPrice(totalPrice));
          $kitDiscountPercent.text(discountType + kitDiscountPercentText);
        }
      };

      formatPrice = function (originalPrice) {
        var price = parseFloat(originalPrice).toFixed(2);
        var parts = price.split('.');
        var integer = parts[0];
        var decimal = parts[1];

        // Defaults to US format
        thousandsSeparator = thousandsSeparator || ',';
        decimalSeparator = decimalSeparator || '.';

        // Insert thousand separator
        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/gu, thousandsSeparator);

        return integer + decimalSeparator + decimal;
      };

      updateKitPrice = function () {
        var totalPrice = 0;
        var $selectedProducts = $('.selected', $kitWrapper).not('.slick-cloned');

        if ($selectedProducts.length > 0) {
          $selectedProducts.each(function () {
            totalPrice += parseFloat($(this).attr('data-price'));
          });
        }
        $kitPriceContainer.text(currencySymbol + formatPrice(totalPrice));
        calculateDiscountPrice(totalPrice);
      };

      getRatingPercentage = function (average) {
        var perc;

        if (!average) {
          return '0%';
        }
        perc = Math.round((average / 5) * 100);

        return perc + '%';
      };

      fetchOffers = function () {
        generic.jsonrpc.fetch({
          method: 'offers.query',
          params: [
            {
              view: 'custom_kitting_in_cart'
            }
          ],
          onSuccess: function (jsonRpcResponse) {
            var response = jsonRpcResponse.getValue();

            if (typeof response !== 'undefined') {
              offerDetails.offers = response.offers;
            }
          },
          onFailure: function () {}
        });
      };

      fetchOffers();
      skuChange = function () {
        $skuSelect.off('change').on('change', function () {
          var $sku = $(this);
          var $selectedSku = $sku.find('option:selected');
          var prodId = $selectedSku.data('prodId');
          var skuShade;
          var $selectedSlick = $();

          if ($sku.hasClass('js-shades')) {
            skuShade = $selectedSku.data('hex-value');
            if (skuShade !== undefined && skuShade !== '') {
              $('.selectBox-active').children('.filtered-swatch').css('background-color', skuShade);
            }
          }

          if ($sku.closest('.js-product-info').length > 0) {
            $selectedSlick = $sku
              .closest('.js-product-info')
              .siblings('.js-product-kit-container')
              .find('.slick-active');
          } else {
            $selectedSlick = $sku.closest('.' + prodId);
          }
          fillProductProperties($selectedSlick, $selectedSku);
          updateKitPrice();
          $sku.closest('.selected').find('.js-kit-product-select-cta').trigger('click');
        });
      };

      if ($shadeSelect !== undefined) {
        $shadeSelect.each(function () {
          var $shade = $(this);
          var $select = $shade.selectbox({
            onOpen: function () {
              var $selectOption = $();
              var $selectMenuOptions = $();

              $('.sbHolder a', $shade).on('click', function (e) {
                e.preventDefault();
              });
              $shade.parent().find('ul.sbOptions').css('overflow', 'auto');
              $selectOption = $shade.data('selectbox-options');
              $selectMenuOptions = $('li a', $selectOption);
              if ($selectMenuOptions.children('.filtered-swatch').length <= 0) {
                $selectMenuOptions.prepend('<div class="filtered-swatch"></div>');
              }
              $selectMenuOptions.each(function () {
                var $options = $(this);
                var shade = $options.attr('rel');

                $options.children('.filtered-swatch').css('background-color', shade);
              });
            },
            onChange: function (val, inst) {
              var selector = $('#sbHolder_' + inst.uid);
              var shadeColor = $(selector).find('a.sbFocus').first().attr('rel');

              $(this)
                .find("option[value='" + val + "']")
                .trigger('change');
              $(selector).css('background-color', shadeColor);
            },
            effect: 'slide'
          });

          $select.next().find('.sbFocus').first().trigger('click');
        });
      }
      $sizeSelector.each(function () {
        var $size = $(this);

        $size.selectbox({
          onOpen: function () {
            $('.sbHolder a', $size).on('click', function (e) {
              var $selectOption = $();
              var $selectMenuOptions = $();

              e.preventDefault();
              $size.closest().find('ul.sbOptions');
              $selectOption = $size.data('selectbox-options');
              $selectMenuOptions = $('li a', $selectOption);
              if ($selectMenuOptions.children('.filtered-swatch').length === 0) {
                $selectMenuOptions.prepend('<div class="filtered-swatch"></div>');
              }
              $selectMenuOptions.each(function () {
                $(this).children('.filtered-swatch');
              });
            });
          },
          onChange: function (val) {
            $(this)
              .find('option[value="' + val + '"]')
              .trigger('change');
          },
          effect: 'slide'
        });
      });

      $productCarousel.slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipe: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

      $productCarousel.find('select').selectbox();
      skuChange();
      $prodSelectedCount.text(productCount);
      $totalProductsCount.text(accordionCount);
      $kitPriceContainer.text(currencySymbol + formatPrice(kitPrice));
      $kitOptions.once().on('click', function (e, disableSrollTop) {
        var $productKit = $();
        var $inactiveKit = $();
        var kitAnchorOffset;

        e.stopPropagation();
        $productKit = $(this).closest('.js-product-kit-v1');
        $inactiveKit = $productKit.siblings('.js-product-kit-v1');
        if ($productKit.hasClass('editable')) {
          $productKit.find('.js-close,.js-edit').toggleClass('hidden');
          $productKit.toggleClass('product-kit__product-added');
        } else {
          $productKit.find('.js-close,.js-select').toggleClass('hidden');
        }
        $inactiveKit.find('.js-product-kit-container,.js-product-info').addClass('hidden');
        $inactiveKit.find('.js-close,.js-edit').addClass('hidden');
        $inactiveKit.find('.js-select').removeClass('hidden');
        $inactiveKit.each(function () {
          var $currentKit = $(this);

          if ($currentKit.hasClass('editable')) {
            $currentKit.addClass('product-kit__product-added');
            $currentKit.find('.js-edit').removeClass('hidden');
            $currentKit.find('.js-select,.js-close').addClass('hidden');
          }
        });

        $productKit.find('.js-product-kit-container').toggleClass('hidden');
        $productKit.find('.js-product-kit-container').slick('setPosition');
        if (!$productKit.find('.js-product-kit-container').hasClass('hidden') && !disableSrollTop) {
          kitAnchorOffset = $productKit.offset().top - $('#page-header-wrapper', context).height();
          $('html, body').animate({ scrollTop: kitAnchorOffset - 90 }, 1000);
        }
      });

      dropdownChange = function ($productKit) {
        var $activeSlide = $();
        var selectedSkuText;

        $activeSlide = $productKit.find('.selected.slick-active');
        selectedSkuText = isMobile
          ? $activeSlide.find('[selected="selected"]').text()
          : $activeSlide.find('span.js-kit-size-option').text();
        if (selectedSkuText) {
          $productKit.find('.js-kit-size-option-selected').text(selectedSkuText);
        }
      };
      productInfo = function ($product, $productKit) {
        var $productDetails = $();
        var skuBaseId;
        var $selectedSku = $();

        $productDetails = $product.find('.js-product-kit-info').children();
        skuBaseId = $product.attr('data-sku-base-id');
        $selectedSku = $productDetails.find('.js-' + skuBaseId + '-info');
        if ($selectedSku.length > 0) {
          $productDetails.find('option').removeAttr('selected');
          $selectedSku.attr('selected', 'selected');
        }
        dropdownChange($productKit);
        skuChange();
      };
      $('.js-kit-img-container, .js-kit-product-select-cta', context).on('click', function (e) {
        var $productImage = $(this);
        var $productKit = $();
        var thisProductId;
        var $thisProduct = $();
        var $product = $();
        var $size = $();
        var $productClone = $();
        var $selectedProducts = $();
        var slickIndex;

        $productKit = $productImage.closest('.js-product-kit-v1');
        $productKit.find('.selected').removeClass('selected');
        thisProductId = $productImage.closest('.js-product-list').attr('data-prod-id');
        $thisProduct = $productKit.find('.' + thisProductId);
        $thisProduct.addClass('selected');
        $product = $productImage.closest('.selected');
        $size = $product.find('.js-sizes option:selected').val();
        $productClone = $product.clone().removeClass('selected slick-active');
        $productClone.find('.product-kit__product-sizes, .product-kit__product-shades').remove();
        $productKit.find('.js-product-thumb').empty().removeClass('hidden').append($productClone);
        $productKit.find('.js-product-title').removeClass('title-active');
        $productKit.find('.selected .js-product-title').addClass('title-active');
        $productKit.find('.js-kit-product-select-cta').text(showSelect);
        $productKit.find('.selected .js-kit-product-select-cta').text(showSelected);
        $productKit.find('.js-product-info').addClass('hidden');
        $selectedProducts = $('.selected', $kitWrapper).not('.slick-cloned');
        productCount = $selectedProducts.length;
        $prodSelectedCount.text(productCount);
        $totalProductsCount.text(accordionCount);
        updateKitPrice();
        if (productCount === accordionCount) {
          $addToBag.removeClass('button--disabled').addClass('active');
        }
        if (isMobile) {
          slickIndex = $productImage.closest('.js-product-list').data('slick-index');
          $productKit.find('.js-product-kit-container').slick('slickGoTo', slickIndex);
        }
        $productKit.find('.icon-selected').addClass('hidden');
        $thisProduct.find('.icon-selected').removeClass('hidden');
        $productKit.addClass('editable');
        $productImage.closest('.js-product-kit-container').find('select').selectbox();
        skuChange();
        e.stopPropagation();
      });

      $productCarousel.on('afterChange', function (e, slick, currentSlide) {
        var $product = $();
        var $productKit = $();

        e.preventDefault();
        $productList.removeClass('current-slide');
        $product = $(slick.$slides[currentSlide]);
        $productKit = $product.closest('.js-product-kit-v1');
        productInfo($product, $productKit);
        $product.addClass('current-slide');
      });

      $firstAccordion = $kitMenuItem.first();
      $firstAccordion.children('.js-kit-label').trigger('click', true);
      $productDetail.on('click', function (e) {
        var index = 0;
        var $imageContainer = $();
        var div;
        var img;
        var productName;
        var productSubheading;
        var averageReview;
        var reviewPercent;
        var overviewWhoisfor;
        var overviewWhatitis;
        var overviewWhatdoesit;

        e.preventDefault();
        $showPopup.toggleClass('popup-details');
        $imageContainer = $(this).parent().find('.js-imagelist');
        $gridImage.empty();
        div = document.createElement('div');
        img = document.createElement('img');
        img.src = $(this).data('prod-image');
        img.setAttribute('class', 'lazyload');
        div.appendChild(img);
        $gridImage.append(div);
        $imageContainer.each(function () {
          div = document.createElement('div');
          img = document.createElement('img');
          img.src = $imageContainer.eq(index).text();
          img.setAttribute('class', 'lazyload');
          div.appendChild(img);
          $gridImage.append(div);
          index++;
        });
        productName = $(this).data('prod-name');
        productSubheading = $(this).data('subtitle');
        $productTitle.text(productName);
        $productSubtitle.text(productSubheading);
        averageReview = $(this).data('prod-rating');
        reviewPercent = getRatingPercentage(averageReview);
        $reviewContainer.css('width', reviewPercent);
        overviewWhoisfor = $(this).data('who-it-is-for');
        overviewWhatitis = $(this).data('what-it-is');
        overviewWhatdoesit = $(this).data('what-it-does');
        if (overviewWhoisfor !== '' && overviewWhoisfor !== undefined) {
          $whoitisfor.html(overviewWhoisfor);
          $whoitisfor.prev().removeClass('hidden');
        } else {
          $whoitisfor.empty();
          $whoitisfor.prev().addClass('hidden');
        }
        if (overviewWhatitis !== '' && overviewWhatitis !== undefined) {
          $whatitis.html(overviewWhatitis);
          $whatitis.prev().removeClass('hidden');
        } else {
          $whatitis.empty();
          $whatitis.prev().addClass('hidden');
        }
        if (overviewWhatdoesit !== '' && overviewWhatdoesit !== undefined) {
          $whatitdoes.html(overviewWhatdoesit);
          $whatitdoes.prev().removeClass('hidden');
        } else {
          $whatitdoes.empty();
          $whatitdoes.prev().addClass('hidden');
        }
      });

      $closePopup.on('click', function (e) {
        e.preventDefault();
        $('body').removeClass('active-gnav');
        $showPopup.toggleClass('popup-details');
      });

      $addToBag.on('click', function () {
        var args = args || {};
        var selectedSkuIds = [];
        var $selectedItem = $('.selected', $kitWrapper).not('.slick-cloned');
        var $selectedItemElem;
        var $this = $(this);
        var defaultSku = $this.attr('data-default-sku');
        var giftwrapSku = $this.attr('data-giftwrap-sku');
        var offerCode = $this.attr('data-offer-code');
        var collectionId;
        var kitName;

        if ($selectedItem.length !== accordionCount) {
          return;
        }

        // Disable the add button to prevent accidental double clicks
        $addToBag.removeClass('active').addClass('button--disabled');

        if (defaultSku !== undefined && defaultSku !== '') {
          selectedSkuIds.push(defaultSku);
        }
        $.each($selectedItem, function () {
          $selectedItemElem = $(this);
          selectedSkuIds.push($selectedItemElem.attr('data-sku-base-id'));
        });
        if (giftwrapSku !== undefined && giftwrapSku !== '') {
          selectedSkuIds.push(giftwrapSku);
        }
        kitName = $this.attr('data-kit-name');
        if (kitName !== undefined && kitName !== '') {
          kitName = kitName + ' ';
        } else {
          kitName = Drupal.settings.default_kit_name;
        }
        args.COLLECTION_TYPE = 'UKIT';
        args.COLLECTION_SUBTYPE = 'CUSTOM_KIT';
        args.SKU_BASE_ID = selectedSkuIds;
        args._SUBMIT = 'alter_collection';
        args.QTY = 1;
        args.COLLECTION_NAME = kitName + Math.floor(Math.random() * 10000);
        args.action = 'add,edit,create_kit';
        args.HAS_MULTIPLE_SKUS = 1;
        if ($.cookie('csrftoken')) {
          args._TOKEN = $.cookie('csrftoken');
        }
        generic.jsonrpc.fetch({
          method: 'Cart',
          params: [args],
          onSuccess: function (res) {
            var responseData = res.getData();

            // Re-enable the add button whether the request was successful or not
            $addToBag.removeClass('button--disabled').addClass('active');

            if (responseData.coll_info) {
              collectionId = responseData.coll_info.COLLECTION_ID;
            } else {
              return;
            }
            generic.jsonrpc.fetch({
              method: 'offers.apply',
              params: [
                {
                  offer_code: offerCode
                }
              ],
              onSuccess: function () {
                generic.jsonrpc.fetch({
                  method: 'trans.get',
                  params: [
                    {
                      trans_fields: ['TRANS_ID', 'totals'],
                      payment_fields: [],
                      order_fields: ['items']
                    }
                  ],
                  onSuccess: function (r) {
                    var resultGetValue = r.getValue();
                    var resultGetData = {};

                    resultGetData.coll_info = {};
                    resultGetData.trans_data = {};
                    resultGetData.trans_data.order = {};
                    resultGetData.trans_data.order.items = {};
                    resultGetData.trans_data.order.kits = {};
                    resultGetData.trans_data.totals = {};
                    resultGetData.coll_info.COLLECTION_ID = collectionId;
                    resultGetData.trans_data.order.items = resultGetValue.order.items;
                    resultGetData.trans_data.totals = resultGetValue.totals;
                    resultGetData.trans_data.items_count = resultGetValue.items_count;
                    $document.trigger('addToCart.success', [resultGetData]);
                  },
                  onFailure: handleServerError
                });
              },
              onFailure: handleServerError
            });
          },
          onFailure: handleServerError
        });
      });
    }
  };
})(jQuery);
